import {
  Box,
  Dialog,
  Divider,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CallIcon from "@mui/icons-material/Call";
import React from "react";
import useStyles from "./styles";

function AllergenInfoModal({ isVisible, toggleModal, restaurantInfo }) {
  const theme = useTheme();
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const restaurantName = restaurantInfo?.name || "Store";
  const restaurantPhone = restaurantInfo?.phone || "";

  return (
    <Dialog
      open={isVisible}
      onClose={toggleModal}
      fullWidth
      maxWidth="sm"
      fullScreen={isSmallScreen}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: { xs: "100%", sm: "680px" },
        },
      }}
    >
      <Box className={classes.container}>
        <IconButton
          onClick={toggleModal}
          className={classes.closeButton}
          aria-label="close allergen info modal"
        >
          <CloseIcon />
        </IconButton>

        <Typography className={classes.title}>Allergen Info</Typography>
        <Divider className={classes.divider} />

        <Typography className={classes.headline}>
          {`${restaurantName} has not provided allergen notes.`}
        </Typography>

        <Typography className={classes.message}>
          {`You can call ${restaurantName} to ask about their ingredients and allergen information, production or cooking methods.`}
        </Typography>

        <Divider className={classes.divider} />

        <Box className={classes.callRow}>
          <CallIcon className={classes.callIcon} />
          {restaurantPhone ? (
            <Typography
              component="a"
              href={`tel:${restaurantPhone}`}
              className={classes.callText}
            >
              {`Call ${restaurantName} on ${restaurantPhone}`}
            </Typography>
          ) : (
            <Typography className={classes.callText}>
              {`Call ${restaurantName}`}
            </Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}

export default React.memo(AllergenInfoModal);
